var cov_9th4325ox = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/utils/accept.ts",
      hash = "69bb92aa41297951c5fb5c2fe11db7e9ac994031",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/utils/accept.ts",
    statementMap: {
      "0": {
        start: {
          line: 4,
          column: 2
        },
        end: {
          line: 21,
          column: 3
        }
      },
      "1": {
        start: {
          line: 5,
          column: 31
        },
        end: {
          line: 5,
          column: 102
        }
      },
      "2": {
        start: {
          line: 6,
          column: 21
        },
        end: {
          line: 6,
          column: 36
        }
      },
      "3": {
        start: {
          line: 7,
          column: 21
        },
        end: {
          line: 7,
          column: 36
        }
      },
      "4": {
        start: {
          line: 8,
          column: 25
        },
        end: {
          line: 8,
          column: 54
        }
      },
      "5": {
        start: {
          line: 10,
          column: 4
        },
        end: {
          line: 20,
          column: 6
        }
      },
      "6": {
        start: {
          line: 11,
          column: 24
        },
        end: {
          line: 11,
          column: 35
        }
      },
      "7": {
        start: {
          line: 12,
          column: 6
        },
        end: {
          line: 14,
          column: 7
        }
      },
      "8": {
        start: {
          line: 13,
          column: 8
        },
        end: {
          line: 13,
          column: 71
        }
      },
      "9": {
        start: {
          line: 15,
          column: 6
        },
        end: {
          line: 18,
          column: 7
        }
      },
      "10": {
        start: {
          line: 17,
          column: 8
        },
        end: {
          line: 17,
          column: 62
        }
      },
      "11": {
        start: {
          line: 19,
          column: 6
        },
        end: {
          line: 19,
          column: 35
        }
      },
      "12": {
        start: {
          line: 22,
          column: 2
        },
        end: {
          line: 22,
          column: 13
        }
      }
    },
    fnMap: {
      "0": {
        name: "attrAccept",
        decl: {
          start: {
            line: 3,
            column: 24
          },
          end: {
            line: 3,
            column: 34
          }
        },
        loc: {
          start: {
            line: 3,
            column: 79
          },
          end: {
            line: 23,
            column: 1
          }
        },
        line: 3
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 10,
            column: 35
          },
          end: {
            line: 10,
            column: 36
          }
        },
        loc: {
          start: {
            line: 10,
            column: 43
          },
          end: {
            line: 20,
            column: 5
          }
        },
        line: 10
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 4,
            column: 2
          },
          end: {
            line: 21,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 4,
            column: 2
          },
          end: {
            line: 21,
            column: 3
          }
        }, {
          start: {
            line: 4,
            column: 2
          },
          end: {
            line: 21,
            column: 3
          }
        }],
        line: 4
      },
      "1": {
        loc: {
          start: {
            line: 4,
            column: 6
          },
          end: {
            line: 4,
            column: 27
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 4,
            column: 6
          },
          end: {
            line: 4,
            column: 10
          }
        }, {
          start: {
            line: 4,
            column: 14
          },
          end: {
            line: 4,
            column: 27
          }
        }],
        line: 4
      },
      "2": {
        loc: {
          start: {
            line: 5,
            column: 31
          },
          end: {
            line: 5,
            column: 102
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 5,
            column: 62
          },
          end: {
            line: 5,
            column: 75
          }
        }, {
          start: {
            line: 5,
            column: 78
          },
          end: {
            line: 5,
            column: 102
          }
        }],
        line: 5
      },
      "3": {
        loc: {
          start: {
            line: 6,
            column: 21
          },
          end: {
            line: 6,
            column: 36
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 6,
            column: 21
          },
          end: {
            line: 6,
            column: 30
          }
        }, {
          start: {
            line: 6,
            column: 34
          },
          end: {
            line: 6,
            column: 36
          }
        }],
        line: 6
      },
      "4": {
        loc: {
          start: {
            line: 7,
            column: 21
          },
          end: {
            line: 7,
            column: 36
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 7,
            column: 21
          },
          end: {
            line: 7,
            column: 30
          }
        }, {
          start: {
            line: 7,
            column: 34
          },
          end: {
            line: 7,
            column: 36
          }
        }],
        line: 7
      },
      "5": {
        loc: {
          start: {
            line: 12,
            column: 6
          },
          end: {
            line: 14,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 12,
            column: 6
          },
          end: {
            line: 14,
            column: 7
          }
        }, {
          start: {
            line: 12,
            column: 6
          },
          end: {
            line: 14,
            column: 7
          }
        }],
        line: 12
      },
      "6": {
        loc: {
          start: {
            line: 15,
            column: 6
          },
          end: {
            line: 18,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 15,
            column: 6
          },
          end: {
            line: 18,
            column: 7
          }
        }, {
          start: {
            line: 15,
            column: 6
          },
          end: {
            line: 18,
            column: 7
          }
        }],
        line: 15
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

export default function attrAccept(file, acceptedFiles) {
  cov_9th4325ox.f[0]++;
  cov_9th4325ox.s[0]++;

  if ((cov_9th4325ox.b[1][0]++, file) && (cov_9th4325ox.b[1][1]++, acceptedFiles)) {
    cov_9th4325ox.b[0][0]++;
    var acceptedFilesArray = (cov_9th4325ox.s[1]++, Array.isArray(acceptedFiles) ? (cov_9th4325ox.b[2][0]++, acceptedFiles) : (cov_9th4325ox.b[2][1]++, acceptedFiles.split(',')));
    var fileName = (cov_9th4325ox.s[2]++, (cov_9th4325ox.b[3][0]++, file.name) || (cov_9th4325ox.b[3][1]++, ''));
    var mimeType = (cov_9th4325ox.s[3]++, (cov_9th4325ox.b[4][0]++, file.type) || (cov_9th4325ox.b[4][1]++, ''));
    var baseMimeType = (cov_9th4325ox.s[4]++, mimeType.replace(/\/.*$/, ''));
    cov_9th4325ox.s[5]++;
    return acceptedFilesArray.some(function (type) {
      cov_9th4325ox.f[1]++;
      var validType = (cov_9th4325ox.s[6]++, type.trim());
      cov_9th4325ox.s[7]++;

      if (validType.charAt(0) === '.') {
        cov_9th4325ox.b[5][0]++;
        cov_9th4325ox.s[8]++;
        return fileName.toLowerCase().endsWith(validType.toLowerCase());
      } else {
        cov_9th4325ox.b[5][1]++;
      }

      cov_9th4325ox.s[9]++;

      if (/\/\*$/.test(validType)) {
        cov_9th4325ox.b[6][0]++;
        cov_9th4325ox.s[10]++;
        // This is something like a image/* mime type
        return baseMimeType === validType.replace(/\/.*$/, '');
      } else {
        cov_9th4325ox.b[6][1]++;
      }

      cov_9th4325ox.s[11]++;
      return mimeType === validType;
    });
  } else {
    cov_9th4325ox.b[0][1]++;
  }

  cov_9th4325ox.s[12]++;
  return true;
}